import { SplitButtonDesignTokens } from '@primeuix/themes/types/splitbutton';

// The two halves inherit the button preset; this only aligns the outer radius.
export const splitButtonPreset: SplitButtonDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
  },
};
